let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hfylG")).then(() => parcelRequire('2sE7K'));